const headerProfileDropdowns = document.querySelectorAll('.header-profile-dropdown');

headerProfileDropdowns.forEach((dropdown) => {
    const trigger = dropdown.querySelector('.header-profile-dropdown__trigger');
    const menu = dropdown.querySelector('.header-profile-dropdown__menu');
    const label = dropdown.querySelector('.header-profile-dropdown__label');
    const nativeSelect = dropdown.querySelector('.header-profile-dropdown__native-select');
    const options = dropdown.querySelectorAll('.header-profile-dropdown__option');

    if (!trigger || !menu || !nativeSelect) {
        return;
    }

    dropdown.classList.add('is-enhanced');

    const closeMenu = () => {
        menu.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        dropdown.classList.remove('is-open');
    };

    const openMenu = () => {
        menu.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        dropdown.classList.add('is-open');
    };

    trigger.addEventListener('click', () => {
        if (menu.hidden) {
            openMenu();
        } else {
            closeMenu();
        }
    });

    options.forEach((option) => {
        option.addEventListener('click', () => {
            const value = option.dataset.value;

            if (!value) {
                return;
            }

            if (label) {
                label.textContent = option.textContent.trim();
            }

            options.forEach((item) => {
                const isSelected = item === option;
                item.classList.toggle('is-selected', isSelected);
                item.setAttribute('aria-selected', isSelected ? 'true' : 'false');
            });

            nativeSelect.value = value;
            nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
            closeMenu();
        });
    });

    document.addEventListener('click', (event) => {
        if (!dropdown.contains(event.target)) {
            closeMenu();
        }
    });

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            closeMenu();
        }
    });
});
